import {
    Container, Typography,
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useEffect, useState } from 'react';
import { LoggedInUser } from '../../../types/auth.types';
import { JobViewModel } from '../../../types/jobs.types';
import Page from '../layout/base.page';
import { safeStringify } from '../utils/json.utils';
import SearchJobs from '../components/SearchJobs/SearchJobs';
import { getUserSearchKeys, summaryCount } from '../../api/stats.api';
import { TagViewModel } from '../../../types/tags.types';
import { AnchorMultiTag } from '../foundation/AnchorTag';
import PopularDomains from '../components/PopularDomains';
import LatestJobs from '../components/LatestJobs';
import AllCategories from '../components/AllCategories';
import AppDescription from '../components/AppDescription/AppDescription';
import AppNumbers from '../components/AppNumbers';
import CustomBR from '../foundation/CustomBR';
import { CompanyViewModel } from '../../../mappers/companyMapper';
import SearchJobsWithWhatsapp from '../components/SearchJobsWithWhatsapp/SearchJobsWithWhatsapp';
import { SmDownBox } from '../foundation/MediaQueryBox';
import {
    ExpressHomeContainer,
    ExpressHomeContent,
    ExpressHomeCta,
    ExpressHomeImage,
    ExpressHomeSection,
    ExpressHomeSubtitle,
    ExpressHomeTitle,
    ExpressHomeTitleAccent,
    ExpressHomeVisual,
    PopularSearchStyled,
    SearchJobsStyled,
} from './Home.page.styles';

type Counters = {
    numberOfJobs: number
    numberOfTodayJobs: number
    numberOfUsers: number
    numberOfTodayWatchedCV: number
};

export type HomePageProps = {
    url: string,
    user?: LoggedInUser
    categories: (TagViewModel & {
        totalJobs: number
    })[],
    popularKeywords: {
        displays?: string
        searchKeyId: number
        tags?: string
        text?: string
        times: number
    }[],
    latestJobs: JobViewModel[],
    companiesWithLogos: CompanyViewModel[],
    jobsCriteria: {
        loc?: string
        address?: string
        lat?: number
        lng?: number
    }
}

// todo, what's that? should i change?
const getSearchScheme = () => safeStringify({
    '@context': 'https://schema.org/',
    '@type': 'WebSite',
    name: 'Mploy',
    url: 'https://www.mploy.co.il/',
    potentialAction: {
        '@type': 'SearchAction',
        target: 'https://www.mploy.co.il/job/search/{search_term_string}',
        'query-input': 'required name=search_term_string',
    },
});

const HomePage = (props: HomePageProps): JSX.Element => {
    const [counters, setCounters] = useState<Counters>(null);
    const [userSearchKeys, setUserSearchKeys] = useState<string[]>([]);

    const fetchCounters = async () => {
        const result = await summaryCount();
        setCounters(result.data as Counters);
    };
    const fetchUserLastSearchKeys = async () => {
        if (props.user) {
            const result = await getUserSearchKeys({ userId: props.user.userid });
            setUserSearchKeys(result.data);
        }
    };
    useEffect(() => {
        fetchCounters();
        fetchUserLastSearchKeys();
    }, []);

    return <Page
        showBreadCrumbs={false}
        beforeBody={<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: getSearchScheme() }} />}
        url={props.url} user={props.user}
        pageHeaderTitle="לוח דרושים חכם לחיפוש עבודה | משרות חדשות מתעדכנות מדי יום" >
        <SearchJobsStyled>
            <Container>
                <SearchJobs
                    defaultLocation={props.jobsCriteria && (props.jobsCriteria.address || props.jobsCriteria.loc)}
                    numberOfTodayJobs={counters?.numberOfTodayJobs}
                    totalJobs={counters?.numberOfJobs}
                />
                <CustomBR h={44} />
            </Container>
        </SearchJobsStyled>
        <ExpressHomeSection aria-label="Mploy Express">
            <ExpressHomeContainer maxWidth="lg">
                <ExpressHomeContent>
                    <ExpressHomeTitle component="h2">
                        <ExpressHomeTitleAccent><bdi dir="ltr">Mploy Express</bdi></ExpressHomeTitleAccent>
                        {' – תנו לקו״ח לעבוד '}
                        <ExpressHomeTitleAccent>בשבילכם</ExpressHomeTitleAccent>
                    </ExpressHomeTitle>
                    <ExpressHomeSubtitle component="p">
                        הירשמו עם אמפלוי אקספרס ואנחנו נמליץ ונשלח את קורות החיים שלכם למעסיקים
                    </ExpressHomeSubtitle>
                    <ExpressHomeCta href="/resume-landing-page">
                        העלאת קו״ח עכשיו
                        <KeyboardArrowLeftIcon aria-hidden="true" />
                    </ExpressHomeCta>
                </ExpressHomeContent>
                <ExpressHomeVisual>
                    <ExpressHomeImage
                        src="/images/resume-upload/express-home.png"
                        alt=""
                        width={1781}
                        height={883}
                        loading="lazy"
                        decoding="async"
                    />
                </ExpressHomeVisual>
            </ExpressHomeContainer>
        </ExpressHomeSection>
        {userSearchKeys?.length > 0 && <PopularSearchStyled>
            <Typography variant="body1">חיפושים אחרונים :</Typography>
            {userSearchKeys.map(searchKey => <AnchorMultiTag key={searchKey} multiTag={searchKey} />)}
        </PopularSearchStyled>}
        {/* popular search does not work and shows volunteer jobs first */}
        {/* <PopularSearchStyled>
            <Typography variant="body1">חיפושים פופולרים :</Typography>
            {popularTags.map(pt => <AnchorTag display={pt.display} key={pt.tag} tag={pt.tag} />)}
            <AnchorTag href="/job/popular" key="popular-jobs" tag="משרות חמות" />
        </PopularSearchStyled> */}
        {/* <CustomBR h={30} /> */}
        {<SmDownBox> <SearchJobsWithWhatsapp /><CustomBR h={44} /></SmDownBox>}

        <PopularDomains numberOfTodayJobs={counters?.numberOfTodayJobs} categories={props.categories} />
        <LatestJobs jobs={props.latestJobs} />
        <AllCategories categories={props.categories} />
        <AppDescription />
        <AppNumbers {...counters} />
        {/* <Container>
            <WhiteBGContainer>
                <Typography textAlign="center" variant="h3" color="secondary" fontWeight="bold">מפרסמים ב-Mploy</Typography>
                <CustomBR h={30} />
                <Grid container spacing={2}>
                    {props.companiesWithLogos.map(company => {
                        const onCompanyClick = () => { window.open(`/job/company/${company.companyid}`, '_blank'); };
                        return <Grid key={company.companyid} item lg={2} md={3} sm={4}>
                            <CompanyWrapper id={company.companyid?.toString()} tabIndex={0} role="button" onClick={onCompanyClick}>
                                <Flexbox alignItems="center" justifyContent="center" height={60}>
                                    <img title={company.name}
                                        loading="lazy"
                                        alt={company.name} width={80} src={`/assets/logos/${company.companyid?.toString().split('').join('/')}/${company.logo}`} />
                                </Flexbox>
                            </CompanyWrapper>
                        </Grid>;
                    })}
                </Grid>
            </WhiteBGContainer>
        </Container> */}
    </Page>;
};

export default HomePage;
